module.exports = __webpack_public_path__ + "static/media/whiteloadingspinner.bf13dec1.svg";